import React, { ReactNode, FC, HTMLAttributes } from 'react';

import styled from '@emotion/styled';
import {
  space,
  layout,
  variant,
  SpaceProps,
  LayoutProps
} from '@lucid/theme';

export interface PaperProps extends SpaceProps, LayoutProps {
  as?: 'div' | 'section' | 'article';
  children: ReactNode;
  variant?: string;
}

const PaperContainer = styled.div<PaperProps>(
  {
    display: 'block',
    textAlign: 'left'
  },
  variant({
    scale: 'paper',
    variants: {
      defaultVariant: {}
    }
  }),
  space,
  layout
);

PaperContainer.defaultProps = {
  variant: 'default'
};

const Paper: FC<HTMLAttributes<HTMLDivElement> & PaperProps> = ({
  children,
  ...rest
}) => <PaperContainer {...rest}>{children}</PaperContainer>;

export { Paper };
export default Paper;
